import React, { useState, useEffect } from 'react';
import styles from '../MobileFilters.module.css';
import Select from 'react-select';
import { people_ages, people_locations, people_cause } from '../FilterOptions';

export const PeopleFilterMobile = (props) => {

    const { applyFilters, resetFilters, filters } = props;

    const [ages, setAges] = useState([]);
    const [locations, setLocations] = useState([]);
    const [cause, setCause] = useState([]);

    useEffect(() => {
        refresh(filters);
    }, [filters]);

    const refresh = (filters) => {

        let ages_array = [];
        people_ages.forEach(el => {
            for (const property in filters) {
                if(el.value === property){
                    ages_array.push(el);
                    break;
                }
            }
        });
        setAges(ages_array);

        let locations_array = [];
        people_locations.forEach(el => {
            for (const property in filters) {
                if(el.value === property){
                    locations_array.push(el);
                    break;
                }
            }
        });
        setLocations(locations_array);

        let cause_array = [];
        people_cause.forEach(el => {
            for (const property in filters) {
                if(el.value === property){
                    cause_array.push(el);
                    break;
                }
            }
        });
        setCause(cause_array);

    }

    const handleReset = () => {
        resetFilters();
        setAges([]);
        setLocations([]);
        setCause([]);
    }

    const handleApply = () => applyFilters([...ages, ...locations, ...cause]);

    return (
        <>
            <span className={styles.filter_question}>Additional Filters</span>

            <div className={styles.cont_actions}>
                <Select
                    isMulti
                    options={people_ages}
                    value={ages}
                    onChange={setAges}
                    className={styles.multi_select}
                    placeholder={"Ages"}
                />
                <Select
                    isMulti
                    options={people_locations}
                    value={locations}
                    onChange={setLocations}
                    className={styles.multi_select}
                    placeholder={"Locations"}
                />
                <Select
                    isMulti
                    options={people_cause}
                    value={cause}
                    onChange={setCause}
                    className={styles.multi_select}
                    placeholder={"Cause"}
                />
            </div>

            <button className={styles.btn_apply} onClick={handleApply}>Apply Filters</button>
            <span className={styles.btn_reset} onClick={handleReset}>Reset All</span>
        </>
    )
}
